// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__yqb2j","nav":"footer_nav__EHA2b","menu_btn":"footer_menu_btn__nl9DE","menu":"footer_menu__Ynf5i","logo":"footer_logo__3K6lc","social":"footer_social__CFbWJ"};